<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useWidgetsStore } from '@/stores/widgets/widgetsStore'
import SSCalculatorWidget from './components/SSCalculatorWidget.vue'
import SSLatestBetslipsWidget from './components/SSLatestBetslipsWidget.vue'
import SSShortcutsWidget from './components/SSShortcutsWidget.vue'

const {
  isCalculatorWidgetSelected,
  isLatestTicketsWidgetSelected,
  isShortcutsWidgetSelected,
  hideWidgets,
} = storeToRefs(useWidgetsStore())

const visibleWidgetCount = computed(
  () =>
    Number(isLatestTicketsWidgetSelected.value) +
    Number(isShortcutsWidgetSelected.value) +
    Number(isCalculatorWidgetSelected.value),
)
</script>

<template>
  <div v-if="!hideWidgets" class="ss-widgets">
    <SSLatestBetslipsWidget v-if="isLatestTicketsWidgetSelected" class="ss-widgets__tab" />
    <SSShortcutsWidget v-if="isShortcutsWidgetSelected" class="ss-widgets__tab" />
    <SSCalculatorWidget
      v-if="isCalculatorWidgetSelected"
      class="ss-widgets__tab ss-widgets__tab--calculator"
      :compact="visibleWidgetCount > 1"
    />
  </div>
</template>

<style lang="scss" scoped>
.ss-widgets {
  display: flex;
  align-items: stretch;
  position: absolute;
  bottom: calc(var(--nxgds-alias-spacing-3xs) + var(--ss-footer-height));
  height: 20rem;
  width: calc(100% - 300px - 3 * var(--nxgds-alias-spacing-3xs));
  padding: var(--nxgds-alias-spacing-3xs) 0;
  z-index: 1;

  &__tab {
    background-color: var(--nxgds-mapped-color-surface-neutral-600);
    border-radius: var(--nxgds-alias-radius-corner-md);
    flex: 1 1 0;
    height: 100%;
    border: 2px solid var(--nxgds-mapped-color-surface-component-page);

    & + & {
      margin-left: -2px;
    }

    &--calculator {
      padding: 0;
    }
  }
}
</style>
